import { useResponsiveStyleWrapper } from '@bingads-webui-campaign-react/unified-app-shared';

const getStyles = () => ({
  formContainer: {
    maxWidth: 680,
    minWidth: 300,
    flex: '1',
  },
});

export const useBudgetStepStyles = () => useResponsiveStyleWrapper(getStyles);
